import { render, staticRenderFns } from "./FooterDocuments.vue?vue&type=template&id=f83d4358&"
import script from "./FooterDocuments.vue?vue&type=script&lang=js&"
export * from "./FooterDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterDocument: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterDocument.vue').default})
